import type { AutoFormWidgetsProps } from '../autoForm'
import { InputWidget } from './inputWidget'

export function EmailWidget(props: AutoFormWidgetsProps) {
  return <InputWidget type="email" {...props} />
}
